<template>
    <component :is="lazyList" v-model="page" :pageCount="pageCount" :filter="filter" :products="products" @input="search">
        <template slot="list-item" slot-scope="{ product }">
            <component :is="lazyListItem" :product="product" />
        </template>
    </component>
</template>
<script>
import api from "@/api";
export default {
    props: {
        skin: { type: String, default: "default" },
        routable: { type: Boolean, default: true },
        isBest: { type: Boolean, default: undefined },
        isRecommend: { type: Boolean, default: undefined },
        searchKey: { type: String },
        searchValue: { type: String },
    },
    data(){
        return {
            filter: {
                type: "main",
                isBest: this.$props.isBest,
                isRecommend: this.$props.isRecommend,
                searchKey: this.$props.searchKey || '',
                searchValue: this.$props.searchValue || ''
            },

            page: 1,
            pageCount: 0,
            limit: this.$attrs.limit || 10,

            summary: { totalCount: 0 },
            products: []
        }
    },
    async mounted(){
        await this.init();
    },
    methods: {
        async init(){
            await this.search(false);
        },
        async search(routable = false){
            if(routable && this.routable){
                this.$router.push({
                    query: { page: this.page, ...this.filter }
                });
            }
            
            let { summary, products } = await api.v1.shop.products.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.products = products;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        }
    },
    computed: {
        lazyList() {
            return () => import(`./skin/${this.$props.skin}/list.vue`);
        },
        lazyListItem() {
            return () => import(`./skin/${this.$props.skin}/list-item.vue`);
        },
    },
    watch: {
        "filter.searchValue"(){ this.search(true); },
        "$props.searchKey"(){ this.filter.searchKey = this.searchKey; },
        "$props.searchValue"(){ this.filter.searchValue = this.searchValue; }
    }
}
</script>